import React from 'react';
import { ProductWidgetDetailV2 } from '../../../../../../types/widget';
import Modal from '../../../../../../components/Modal';
import ProductWidgetGridLayout from './ProductWidgetGridLayout';
import ProductWidgetSwipeLayout from './ProductWidgetSwipeLayout';
import ProductWidgetGalleryLayout from './ProductWidgetGalleryLayout';
import { ProductWidgetGridLayoutDetail } from './ProductWidgetGridLayout/ProductWidgetGridLayout';
import { ProductWidgetSwipeLayoutDetail } from './ProductWidgetSwipeLayout/ProductWidgetSwipeLayout';
import { ProductWidgetGalleryLayoutDetail } from './ProductWidgetGalleryLayout/ProductWidgetGalleryLayout';
import WidgetPreviewHeader from '../../../common/components/WidgetPreviewHeader';
import { ProductWidgetPreviewModalButton } from './style';
import { sampleSize } from 'lodash';

interface ProductWidgetPreviewModalProps {
  detail: ProductWidgetDetailV2;
  onClose: () => void;
}

const ProductWidgetPreviewModal = (props: ProductWidgetPreviewModalProps): JSX.Element => {
  const { detail, onClose } = props;

  const getLayoutView = (detail: ProductWidgetDetailV2): JSX.Element => {
    const previewDetail = detail.isRandomItem
      ? {
          ...detail,
          exposureWidgetItemProducts: sampleSize(detail.widgetItemProducts, detail.exposureItemCount),
        }
      : { ...detail, exposureWidgetItemProducts: detail.exposureWidgetItemProducts };

    switch (detail.layoutType) {
      case 'grid2x2':
      case 'grid3x2':
        return <ProductWidgetGridLayout detail={previewDetail as ProductWidgetGridLayoutDetail} />;
      case 'swipeBig1xn':
      case 'swipeSmall1xn':
        return <ProductWidgetSwipeLayout detail={previewDetail as ProductWidgetSwipeLayoutDetail} />;
      case 'gallery3x3':
        return <ProductWidgetGalleryLayout detail={previewDetail as ProductWidgetGalleryLayoutDetail} />;
      default:
        return <ProductWidgetGridLayout detail={previewDetail as ProductWidgetGridLayoutDetail} />;
    }
  };

  return (
    <Modal
      title={'위젯 미리보기'}
      wrapClassName="widget-preview-modal-wrapper"
      isOpen={true}
      width={375}
      height={700}
      padding={'0px'}
      isFooter={true}
      okText="확인"
      onOk={onClose}
      onClose={onClose}
    >
      <WidgetPreviewHeader mainTitle={detail.mainTitle} subTitle={detail.subTitle} />
      {getLayoutView(detail)}
      {!detail.isProductRecommend && (
        <ProductWidgetPreviewModalButton>
          <button>
            {detail.buttonText ? detail.buttonText : <span className="require-info">위젯 버튼명을 설정해주세요.</span>}
          </button>
        </ProductWidgetPreviewModalButton>
      )}
    </Modal>
  );
};

export default ProductWidgetPreviewModal;
